<template>
  <insurance-form
    :initInsurance="initInsurance"
    :successMsg="t('created')"
    :submitAction="submit"
    enableClearForm
    clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InsuranceForm from '@/views/companies/insurances/InsuranceForm.vue'

import Insurance from '@/models/insurance/Insurance'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-insurance',

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          created: 'Insurance company was created successfully'
        },
        ar: {
          created: 'تم انشاء شركة التأمين بنجاح'
        }
      }
    })

    return { t }
  },

  components: {
    InsuranceForm
  },
  data() {
    return {
      initInsurance: new Insurance()
    }
  },

  methods: {
    async submit(insurance: Insurance) {
      try {
        await this.$http.post(Insurance.ENDPOINT, insurance)
        await this.$router.push(this.$Route.INSURANCES)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
